{
  "sessionExpired": "Your session has expired - please sign in again",
  "codeVerified": "Your code has been verified",
  "passwordChanged": "Your password has been changed",
  "accountCreated": "Your account has been created",
  "accountDeleted": "Your account has been deleted",
  "unableToDeleteAccount": "We were unable to delete your account, please try again",
  "bookingDetailsUpdated": "Booking details updated",
  "addStopError": "Unable to add stop",
  "editStopError": "Unable to edit stop",
  "removeStopError": "Unable to remove stop",
  "locationError": "Unable to retrieve location",
  "defaultAddressError": "Unable to retrieve default address",
  "delayError": "Unable to retrieve booking delay",
  "unableToCompletePayment": "We were unable to complete your payment, please try again",
  "unableToProceedBooking": "We were unable to proceed with this booking, please try again",
  "unableToAddCard": "We were unable to add your card, please try again",
  "unableToDeleteCard": "We were unable to delete your card, please try again",
  "unableToDefaultCard": "We were unable to default your card, please try again",
  "profileUpdated": "Your profile has been updated",
  "editProfileError": "Unable to edit profile",
  "cardAdded": "Your card has been added",
  "cardDeleted": "Your card has been deleted",
  "cardDefaulted": "Your default card has been updated",
  "unableToCancelBooking": "We were unable to cancel this booking",
  "unableToEditBooking": "We were unable to edit this booking",
  "unableToCopyBooking": "We were unable to copy this booking",
  "favouriteAdded": "Favourite Added",
  "favouriteCleared": "Favourite Cleared",
  "favouriteEdited": "Favourite Edited",
  "unableToAddFavourite": "We were unable to add this favourite",
  "unableToClearFavourite": "We were unable to clear this favourite",
  "unableToEditFavourite": "We were unable to edit this favourite",
  "unableToFindBookingTemplate": "Unable to find booking template",
  "unableToSearchForAddresses": "Unable to search for addresses",
  "unableToSearchForContacts": "Unable to search for contacts",
  "unableToSearchForReports": "Unable to search for reports",
  "unableToLoadJourneyDetails": "Unable to load journey details",
  "secretKeyCopied": "Secret key copied",
  "contactLink": {
    "contactLinkRequestSent": "Contact link request sent",
    "contactLinkRequestFailed": "Contact link request failed",
    "unableToLoadLinkedContacts": "Unable to load linked contacts",
    "contactLinkAuthorised": "Contact link authorised",
    "contactLinkRejected": "Contact link rejected"
  },
  "jobDetailsCopied": "Job details copied to clipboard",
  "unableToSignOn": "Unable to complete sign on",
  "vouchers": {
    "voucherRemoved": "Voucher {voucherCode} removed",
    "unableToAddVoucher": "Unable to add voucher",
    "voucherAdded": "Voucher {voucherCode} added",
    "voucherAlreadyAdded": "Voucher {voucherCode} has already been added"
  },
  "unableToOpenFile": "Unable to open {file}",
  "missingFormData": "Missing form data",
  "missingLeadPassengerDetails": "Missing lead passenger details",
  "quickQuoteUnavailable": "Quick quote unavailable",
  "reporting": {
    "export": {
      "copyMessage": "Report copied",
      "error": "Export error"
    }
  },
  "deviceIntegrityWarning": "This device appears to be modified, which may put your data at risk",
  "newNotification": "New Notification"
}
